import React, { useEffect, useState } from "react";
import { InputFieldComponent } from "components/form/input_field";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { bellIcon, logoImg, searchIcon, userProfileImg } from "utils/data";

export const NavbarSection = ({ showLogo }) => {
  const [navbarTitle, setNavbarTitle] = useState("");
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "") {
      setNavbarTitle("Map View");
    } else if (location.pathname === "/compare") {
      setNavbarTitle("Compare");
    } else if (location.pathname === "/plain-text") {
      setNavbarTitle("Plain and Text");
    } else if (location.pathname === "/import-export") {
      setNavbarTitle("Import and Export");
    } else if (location.pathname === "/reports") {
      setNavbarTitle("Reports");
    } else if (location.pathname === "/save-load") {
      setNavbarTitle("Save and Load");
    }
  }, [location.pathname]);

  return (
    <Navbar expand="md" className="bg-body-tertiary">
      <Container>
        {showLogo && (
          <Navbar.Brand as="div" className="me-md-5">
            <img src={logoImg} alt="logo" width={150} />
          </Navbar.Brand>
        )}
        <Navbar.Brand as="div">
          <h3 className="m-0">{navbarTitle}</h3>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center d-flex flex-row gap-3">
            <Nav.Link as="div">
              <div className="bg-white rounded-circle p-2 navbar-icon d-flex justify-content-center align-items-center pe-cursor">
                <img src={bellIcon} alt="Notification" />
              </div>
            </Nav.Link>
            <Nav.Link as="div" className="flex-fill">
              <InputFieldComponent
                prefixIcon={<img src={searchIcon} alt="Search" />}
                placeholder="Search here...."
                onChange={() => {}}
              />
            </Nav.Link>
            <Nav.Link as="div">
              <Link to="/login">
                <div className="navbar-icon pe-cursor">
                  <img
                    src={userProfileImg}
                    alt="User Profile"
                    width={60}
                    height={60}
                    className="img-fluid rounded-circle"
                  />
                </div>
              </Link>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
